// extracted by mini-css-extract-plugin
module.exports = {"container-lds":"style_container-lds__16pIc","lds-roller":"style_lds-roller__Eyw9z","primary":"style_primary__14VQK"};